import { useAbility } from '@/modules/identity/application/ability';
import { useI18n } from '@/shared/i18n';
import React from 'react';
import { RoutineList } from '../components/RoutineList';

export const AdminRoutinesPage: React.FC = () => {
  const { t } = useI18n();
  const ability = useAbility();

  if (!ability.can('manage', 'all') && !ability.can('manage', 'Routine') && !ability.can('read', 'Routine')) {
    return (
      <div className="flex items-center justify-center p-12 text-slate-400">
        No tienes permisos para ver esta sección.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">{t('routines.title')}</h1>
        <p className="text-sm text-slate-500 mt-1">{t('routines.subtitle')}</p>
      </div>
      <RoutineList />
    </div>
  );
};
